import RU from '../../assets/i18n/RU.json';
import EN from '../../assets/i18n/EN.json';

export const UNAUTHORIZED_ERROR_CODE = 401;
export const FORBIDDEN_ERROR_CODE = 403;
export const SERVER_ERROR_CODE = 500;
export const NO_INTERNET_CONNECTION_CODE = 0;

export const UNAUTHORIZED_AND_FORBIDDEN_CODES = [
  UNAUTHORIZED_ERROR_CODE,
  FORBIDDEN_ERROR_CODE,
];

export const ERROR_MESSAGES = {
  [NO_INTERNET_CONNECTION_CODE]: {
    RU: RU.errors.noInterNetConnection,
    EN: EN.errors.noInterNetConnection,
  },
  [UNAUTHORIZED_ERROR_CODE]: {
    RU: RU.errors.unauthorized,
    EN: EN.errors.unauthorized,
  },
};

export enum AuctionType {
  englishUpgrading = 1,
  dutchDown = 2,
  doubleCounter = 4
}

export enum IdDirection {
  buy = 1,   //покупка
  sale = 2 //продажа
}

export enum IdSection {
  metalProducts = 1,           //метал
  forestProducts = 2,          //лес
  agricultural = 3,             //сельхоз
  promising = 7            //перспективные
}

export const SECONDS_IN_DAY: number = 86400;

export const SECONDS_IN_HOUR: number = 3600;

export const SECONDS: number = 60;
